import { Link } from "react-router-dom";
import PlayIcon from "@components/media/PlayIcon";

export default function SubscriptionMovieCard({ item }) {
  const Wrapper = item.href ? Link : "div";
  const wrapperProps = item.href ? { to: item.href } : {};

  return (
    <Wrapper
      {...wrapperProps}
      style={{
        cursor: "pointer",
        color: "inherit",
        display: "block",
        width: "100%",
        textDecoration: "none",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          aspectRatio: "2 / 3",
          borderRadius: 12,
          overflow: "hidden",
          background: item.bg,
          marginBottom: 7,
        }}
      >
        <img
          src={item.img}
          alt={item.title}
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.9,
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 6,
            left: 6,
            background: "rgba(0,0,0,0.3)",
            width: 44,
            height: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#EBEBEB",
            fontSize: 13,
            fontWeight: 700,
            padding: "2px 6px",
            borderRadius: 8,
            gap: 2,
          }}
          className="inter-s"
        >
          {item.rating}
        </div>
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background .25s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(0,0,0,.38)";
            e.currentTarget.querySelector(".pi").style.opacity = "1";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(0,0,0,0)";
            e.currentTarget.querySelector(".pi").style.opacity = "0";
          }}
        >
          <span
            className="pi"
            style={{ opacity: 0, transition: "opacity .25s" }}
          >
            <PlayIcon />
          </span>
        </div>
      </div>
      <div
        style={{
          fontSize: 22,
          color: "#BABABA",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          marginBottom: 2,
        }}
        className="jost-s"
      >
        {item.title}
      </div>
      <div style={{ fontSize: 15, color: "#4B4B4B" }} className="inter-m">
        {item.year} , {item.type}
      </div>
    </Wrapper>
  );
}
